import { apiService } from '@/utils/api/index';
import axios from 'axios';

export default {
  getCountries() {
    return apiService.tabGet('/locations/cities_q/');
  },

  getStates(id) {
    return apiService.tabGet(`/locations/cities_q/?country=${id}`);
  },

  getCities(payload) {
    return apiService.tabGet(
      `/locations/cities_q/?country=${payload.countryId}&state=${payload.stateId}`
    );
  },

  getUserInfo() {
    return apiService.get('/users/me/');
  },

  saveUserInfo(data) {
    return apiService.patch('/users/me/', data);
  },

  async saveUserPassword(data) {
    return await axios.put('/auth/password/', data);
  },

  getUsersByOrganization() {
    return apiService.get(
      '/users/user-invites/by-org/?sort=first_name_and_name'
    );
  },

  sendUserInvite(data) {
    return apiService.post('/users/invite/', data);
  },

  resendUserInvite(id) {
    return apiService.post(`/users/invite/resend/${id}/`);
  },

  deleteUser(id) {
    return apiService.delete(`/users/remove/user/${id}/`);
  },

  getApiKey(id) {
    return apiService.get(`/users/token/${id}/`);
  },

  generateApiKey(id) {
    return apiService.post(`/users/token/${id}/`);
  },

  disableApiKey(id) {
    return apiService.delete(`/users/token/${id}/`);
  },
};
